
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.99998 1.31418C5.20296 1.31418 1.31418 5.20296 1.31418 10.0001C1.31418 14.7971 5.20296 18.6859 9.99998 18.6859C14.7971 18.6859 18.6858 14.7971 18.6858 10.0001C18.6858 5.20296 14.7971 1.31418 9.99998 1.31418ZM0 10.0001C0 4.47716 4.47716 0 9.99998 0C15.5229 0 20 4.47716 20 10.0001C20 15.5228 15.5229 20.0001 9.99998 20.0001C4.47716 20.0001 0 15.5228 0 10.0001ZM9.99998 4.83033C10.363 4.83033 10.6571 5.12452 10.6571 5.48742V9.58092L13.3925 10.8527C13.7216 11.0057 13.8644 11.3965 13.7113 11.7256C13.5583 12.0546 13.1675 12.1974 12.8384 12.0444L9.72295 10.5958C9.49122 10.4881 9.34289 10.2556 9.34289 10.0001V5.48742C9.34289 5.12452 9.63709 4.83033 9.99998 4.83033Z","fill":"#8338EC"}})])
          )
        }
      }
    